<div class="pl-2 pr-2">
  <app-calendar-subagent-table (chageTable)="onChange('physical', $event['id'], $event['caption'])"
    [realty_list]="realty_list"
  [ngStyle]="{'display': (view == 'subagent') ? 'block' : 'none' }"></app-calendar-subagent-table>
  @if (view == 'physical') {
    <app-calendar-physical-table [subagent_id]="subagent_id" [subagent_caption]="subagent_caption"
      [event_list]="event_list"
    (chageTable)="onChange('subagent')"></app-calendar-physical-table>
  }
</div>
